import { CircularProgress } from '@mui/material';
import React from 'react';

interface IProps {
    data: { label: string; count: number }[];
    totalCount: number;
    loader: boolean;
    heading: string;
};

const ProgressGraph: React.FC<IProps> = ({
    data = [],
    totalCount = 1,
    loader = false,
    heading = ""
}) => {
    return (
        <div style={{ height: '100%' }}>
            <h2 className="font-Poppins-SemiBold text-[#232323] font-size-20px mb-2">{heading}</h2>
            {loader &&
                <div className="text-center">
                    <CircularProgress size={20} style={{ color: "#004540" }} />
                </div>
            }
            <div className="flex flex-col gap-3 h-full">
                {data.map((item, index) => (
                    <div key={index} className="border border-[#004641] p-2 rounded-md">
                        <div className="flex justify-between mb-2">
                            <span className="font-Poppins-Medium font-size-16px mb-0">{item?.label || "-"}</span>
                            <span className="font-Poppins-Medium font-size-16px mb-0">{item?.count || "-"}</span>
                        </div>
                        <div className="relative w-full h-1 bg-gray-200 rounded">
                            <div className="absolute top-0 left-0 h-1 bg-[#004641] rounded" style={{ width: `${(item?.count / totalCount) * 100 || 0}%` }}></div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ProgressGraph;